import { render } from "./staff-list.vue?vue&type=template&id=5087a0c4"
import script from "./staff-list.vue?vue&type=script&lang=js"
export * from "./staff-list.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__